import type { ReactNode } from "react";

type ListLayoutProps = {
  /**
   * The main title of the page
   */
  title: string;
  /**
   * Description text shown below the title
   */
  description: string | ReactNode;
  /**
   * Action buttons/triggers to display in the header (e.g., "Add Project" button)
   */
  actions?: ReactNode;
  /**
   * Optional content to display between header and main content (e.g., warnings, alerts)
   */
  beforeContent?: ReactNode;
  /**
   * Optional search/filter controls to display before the main content
   */
  filters?: ReactNode;
  /**
   * The main content of the page (e.g., table, grid, etc.)
   */
  children: ReactNode;
};

export const ListLayout = ({
  title,
  description,
  actions,
  beforeContent,
  filters,
  children,
}: ListLayoutProps) => {
  return (
    <div className="flex flex-col gap-4">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-2">
          <h1 className="font-bold text-2xl">{title}</h1>
          <p className="text-muted-foreground text-sm">{description}</p>
        </div>
        {!!actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>

      {/* Optional Before Content (e.g., warnings, alerts) */}
      {beforeContent}

      {/* Optional Filters/Search Section */}
      {!!filters && (
        <div className="mt-4 flex items-center justify-between">{filters}</div>
      )}

      {/* Main Content */}
      {children}
    </div>
  );
};
